import store from '../store'
// import axios from 'axios'
import { Message, Loading } from 'element-ui'

const axios = require('axios')

// 配置API接口地址，正常使用端口为5002
var baseURL = 'http://buchimian.cn:5555/'
// 自定义判断元素类型JS
function toType(obj) {
  return {}.toString
    .call(obj)
    .match(/\s([a-zA-Z]+)/)[1]
    .toLowerCase()
}
// 参数过滤函数
function filterNull(o) {
  for (var key in o) {
    if (o[key] === null) {
      delete o[key]
    }
    if (toType(o[key]) === 'string') {
      o[key] = o[key].trim()
    } else if (toType(o[key]) === 'object') {
      o[key] = filterNull(o[key])
    } else if (toType(o[key]) === 'array') {
      o[key] = filterNull(o[key])
    }
  }
  return o
}

// http request 拦截器
axios.interceptors.request.use(
  config => {
    if (store.state.token) {
      config.headers.Authorization = `Bearer ${store.state.token}`
    }
    return config
  },
  err => {
    return Promise.reject(err)
  }
)

// http response 拦截器
axios.interceptors.response.use(
  response => {
    return response
  },
  error => {
    if (error.response) {
      switch (error.response.status) {
        case 401:
          // 401 清除token信息并跳转到登录页面
          store.commit('logout')
          let pathname = window.location.pathname;
          console.log(pathname);
          if (!pathname || pathname=='/'|| pathname == '/index.html') {
            //首页不提示错误信息和跳转到登录页
          }
          else {
            Message({
              message: '尚未登录或登录信息已失效，请重新登录！',
              type: 'error'
            })
            let uri = window.location.href
            document.cookie = 'redirect_uri=' + encodeURI(uri) + '; path=/'
            window.location.href = '/static/login/weixin.html'
          }
      }
    }
    // console.log(JSON.stringify(error));//console : Error: Request failed with status code 402
    return Promise.reject(error.response.data)
  }
)

function apiAxios(method, url, params, success, failure, loadingDom) {
  if (params) {
    params = filterNull(params)
  }
  let loading
  if (loadingDom) {
    loading = Loading.service({
      lock: true,
      text: '拼命加载中',
      target: loadingDom
    })
  }

  axios({
    method: method,
    url: url,
    data: method === 'POST' || method === 'PUT' ? params : null,
    params: method === 'GET' || method === 'DELETE' ? params : null,
    // headers: { Authorization: 'Bearer xxxxxxx' },
    baseURL: baseURL,
    withCredentials: false
  })
    .then(function (res) {
      if (loading) {
        loading.close()
      }
      res = res.data
      if (res.Code === 1) {
        if (success) {
          success(res.Data)
        } else {
          Message({
            message: res.Msg,
            type: 'success'
          })
        }
      } else {
        if (failure) {
          failure(res)
        } else {
          Message({
            message: res.ErrMsg,
            type: 'error'
          })
        }
      }
    })
    .catch(function (err) {
      if (loading) {
        loading.close()
      }
      Message({
        message: JSON.stringify(err),
        type: 'error'
      })
    })
}

function apiAxiosAsync(method, url, params) {
  return new Promise(function (resolve, reject) {
    if (params) {
      params = filterNull(params)
    }
    axios({
      method: method,
      url: url,
      data: method === 'POST' || method === 'PUT' ? params : null,
      params: method === 'GET' || method === 'DELETE' ? params : null,
      // headers: { Authorization: 'Bearer xxxxxxx' },
      baseURL: baseURL,
      withCredentials: false
    })
      .then(function (res) {
        res = res.data
        if (res.Code === 1) {
          resolve(res.Data)
        } else {
          Message({
            message: res.ErrMsg,
            type: 'error'
          })
        }
      })
      .catch(function (err) {
        try {
          reject(err)
        } catch (ex) {
          Message({
            message: err.ErrMsg,
            type: 'error'
          })
        }
      })
  })
}

// 返回在vue模板中的调用接口
export default {
  apiAxiosAsync,
  get: function (url, params, success, failure, loadingDom) {
    return apiAxios('GET', url, params, success, failure, loadingDom)
  },
  post: function (url, params, success, failure, loadingDom) {
    return apiAxios('POST', url, params, success, failure, loadingDom)
  },
  put: function (url, params, success, failure, loadingDom) {
    return apiAxios('PUT', url, params, success, failure, loadingDom)
  },
  delete: function (url, params, success, failure, loadingDom) {
    return apiAxios('DELETE', url, params, success, failure, loadingDom)
  },
  query: function (url, params, filter, sort, success, failure, loadingDom) {
    var p = {
      FilterInfo: filter,
      SortInfo: sort,
      SearchInfo: params
    }
    return apiAxios('POST', url, p, success, failure, loadingDom)
  },
  queryPage: function (
    url,
    params,
    page,
    filter,
    sort,
    success,
    failure,
    loadingDom
  ) {
    var p = {
      FilterInfo: filter,
      SortInfo: sort,
      PageInfo: page,
      SearchInfo: params
    }
    return apiAxios('POST', url, p, success, failure, loadingDom)
  }
}



// WEBPACK FOOTER //
// ./src/api/http.js